var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_INVOICE_MODULE_CFDI = "api/invoice-module/cfdi";
const GET_INVOICE_MODULE_CAPABILITIES = "api/invoice-module/capabilities";
export const getCapabilities = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(GET_INVOICE_MODULE_CAPABILITIES, config);
        }
        catch (error) {
            console.error("Error fetching invoice module capabilities:", error);
            throw error;
        }
    });
};
export const getCFDIList = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                "query",
                "storeId",
                "fromDate",
                "toDate",
                "limit",
                "pageNum"
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_INVOICE_MODULE_CFDI}?${queryParams}`, config);
        }
        catch (error) {
            console.error("Error fetching invoice module CFDI list:", error);
            throw error;
        }
    });
};
export const getCFDIPreview = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                "ordersID",
                "customer",
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_INVOICE_MODULE_CFDI}/preview?${queryParams}`, config);
        }
        catch (error) {
            console.error("Error fetching invoice module CFDI preview:", error);
            throw error;
        }
    });
};
export const sendCFDIByEmail = function (invoiceID) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_INVOICE_MODULE_CFDI}/${invoiceID}/email`, config);
        }
        catch (error) {
            console.error("Error sending invoice module CFDI by email:", error);
            throw error;
        }
    });
};
export const downloadCFDIPDF = function (invoiceID) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                },
                responseType: "arraybuffer"
            };
            return yield this.axiosInstance.get(`${GET_SET_INVOICE_MODULE_CFDI}/${invoiceID}/download/pdf`, config);
        }
        catch (error) {
            console.error("Error fetching invoice module CFDI PDF:", error);
            throw error;
        }
    });
};
export const downloadCFDIZIP = function (invoiceID) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                },
                responseType: "arraybuffer"
            };
            return yield this.axiosInstance.get(`${GET_SET_INVOICE_MODULE_CFDI}/${invoiceID}/download/zip`, config);
        }
        catch (error) {
            console.error("Error fetching invoice module CFDI ZIP:", error);
            throw error;
        }
    });
};
export const getCFDIProductCatalogs = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                "search",
                "q",
            ], params);
            const queryParamsSuffix = queryParams ? `?${queryParams}` : "";
            return yield this.axiosInstance.get(`${GET_SET_INVOICE_MODULE_CFDI}/catalogs/products${queryParamsSuffix}`, config);
        }
        catch (error) {
            console.error("Error fetching invoice module CFDI product catalogs:", error);
            throw error;
        }
    });
};
